// extracted by mini-css-extract-plugin
var _1 = "LinkCursorSelection-module__container--rszxN";
var _2 = "LinkCursorSelection-module__link--Imjx8";
export { _1 as "container", _2 as "link" }
